import styles from "./searchFast.module.css"
// import { useEffect, useState, useCallback } from "react"
import { useMediaQuery } from "react-responsive"
import { useDispatch, useSelector } from "react-redux"
// import { useActiveButtonCountryTagChoice } from "../../services/context/CountryFilterContext"
// import { useActiveFilters } from "../../services/context/ActiveFiltersContext"
import checkBoxEmpty from "../../images/check-box-empty.svg"
import arrowImgPopular from "../../images/sort-arrow-popular.svg"
import arrowDownGreen from "../../images/arrow-down-sign-to-navigate-green.svg"
import checkBoxFull from "../../images/check-box-full.svg"
import {
  setSelectAnalysisPoint,
  setSelectSubscriptionPoint,
  setSelectBondsPoint,
} from "../../services/reducers/search-vision-points-slice"
import {
  setAnalysisPoints,
  setSubscriptionPoints,
  setBondsPoints,
} from "../../services/reducers/cards-filtred-slice"
import {
  selectAnalysisVision,
  selectSubscriptionVision,
  selectBondsVision,
} from "../../services/selectors"
import { useActiveFilters } from "../../services/context/ActiveFiltersContext"
import { useCallback } from "react"

const SearchSectionFast = ({ selectRelevant, setActivRelevantWind }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 760px)" })
  const dispatch = useDispatch()
  const selectAnalysisPoint = useSelector(selectAnalysisVision)
  const selectSubscription = useSelector(selectSubscriptionVision)
  const selectBonds = useSelector(selectBondsVision)
  const filters = useActiveFilters()

  return (
    <>
      {!isMobile && (
        <section className={styles.section}>
          <div className={styles.container}>
            <div className={styles.sectionPointsWrapper}>
              <div className={styles.sectionPoint}>
                {!selectSubscription ? (
                  <img
                    alt="img"
                    src={checkBoxEmpty}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectSubscriptionPoint(true))
                      dispatch(setSubscriptionPoints("&subscription=2,4,5"))
                      filters.setPageCount(1)
                    }}
                  />
                ) : (
                  <img
                    alt="img"
                    src={checkBoxFull}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectSubscriptionPoint(false))
                      dispatch(setSubscriptionPoints(""))
                      filters.setPageCount(1)
                    }}
                  />
                )}
                С подпиской Unity
              </div>
              {/*
       <div className={styles.sectionPoint}>
       <img src={checkBoxEmpty} className={styles.checkBoxEmpty}/>

       C подпиской Ideas
       </div>
        */}
              <div className={styles.sectionPoint}>
                {!selectAnalysisPoint ? (
                  <img
                    alt="img"
                    src={checkBoxEmpty}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectAnalysisPoint(true))
                      dispatch(setAnalysisPoints("&analysis=true"))
                      filters.setPageCount(1)
                    }}
                  />
                ) : (
                  <img
                    alt="img"
                    src={checkBoxFull}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectAnalysisPoint(false))
                      dispatch(setAnalysisPoints(""))
                      filters.setPageCount(1)
                    }}
                  />
                )}
                Разборы компаний
              </div>

              <div className={styles.sectionPoint}>
                {!selectBonds ? (
                  <img
                    alt="img"
                    src={checkBoxEmpty}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectBondsPoint(true))
                      dispatch(setBondsPoints("&bonds=true"))
                      filters.setPageCount(1)
                    }}
                  />
                ) : (
                  <img
                    alt="img"
                    src={checkBoxFull}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectBondsPoint(false))
                      dispatch(setBondsPoints(""))
                      filters.setPageCount(1)
                    }}
                  />
                )}
                Облигации
              </div>
            </div>

            <div className={styles.relevantSectionWrapper}>
              <div
                className={styles.relevantSection}
                onClick={() => {
                  setActivRelevantWind((prev) => !prev)
                }}
              >
                <img
                  alt="img"
                  src={arrowImgPopular}
                  className={styles.arrowImgPopular}
                />
                <div className={styles.txtButtom}>{selectRelevant}</div>
                <img
                  alt="img"
                  src={arrowDownGreen}
                  className={styles.arrowDownGreen}
                />
              </div>
            </div>
          </div>
        </section>
      )}

      {isMobile && (
        <section className={styles.section}>
          <div className={styles.container}>
            <div className={styles.sectionPointsWrapper}>
              <div className={!selectAnalysisPoint ? styles.sectionPoint : styles.sectionPointActive}
              onClick={() => {
                if (!selectAnalysisPoint) {
                  dispatch(setSelectAnalysisPoint(true))
                  dispatch(setAnalysisPoints("&analysis=true"))
                  filters.setPageCount(1)
                } else {
                  dispatch(setSelectAnalysisPoint(false))
                  dispatch(setAnalysisPoints(""))
                  filters.setPageCount(1)
                }
              }}
              >
                {!selectAnalysisPoint ? (
                  <img
                    alt="img"
                    src={checkBoxEmpty}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectAnalysisPoint(true))
                      dispatch(setAnalysisPoints("&analysis=true"))
                      filters.setPageCount(1)
                    }}
                  />
                ) : (
                  <img
                    alt="img"
                    src={checkBoxFull}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectAnalysisPoint(false))
                      dispatch(setAnalysisPoints(""))
                      filters.setPageCount(1)
                    }}
                  />
                )}
                Разборы компаний
              </div>

              <div className={!selectSubscription ? styles.sectionPoint : styles.sectionPointActive}
              onClick={() => {
                if (!selectSubscription) {
                    dispatch(setSelectSubscriptionPoint(true))
                    dispatch(setSubscriptionPoints("&subscription=2,4,5"))
                    filters.setPageCount(1)
                } else {
                    dispatch(setSelectSubscriptionPoint(false))
                    dispatch(setSubscriptionPoints(""))
                    filters.setPageCount(1)
                }
              }}
              >
                {!selectSubscription ? (
                  <img
                    alt="img"
                    src={checkBoxEmpty}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectSubscriptionPoint(true))
                      dispatch(setSubscriptionPoints("&subscription=2,4,5"))
                      filters.setPageCount(1)
                    }}
                  />
                ) : (
                  <img
                    alt="img"
                    src={checkBoxFull}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectSubscriptionPoint(false))
                      dispatch(setSubscriptionPoints(""))
                      filters.setPageCount(1)
                    }}
                  />
                )}
                С подпиской Unity
              </div>

              <div
                className={!selectBonds ? styles.sectionPoint : styles.sectionPointActive}
                onClick={() => {
                  if (!selectBonds) {
                    dispatch(setSelectBondsPoint(true))
                    dispatch(setBondsPoints("&bonds=true"))
                    filters.setPageCount(1)
                  } else {
                    dispatch(setSelectBondsPoint(false))
                    dispatch(setBondsPoints(""))
                    filters.setPageCount(1)
                  }
                }}
              >
                {!selectBonds ? (
                  <img
                    alt="img"
                    src={checkBoxEmpty}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectBondsPoint(true))
                      dispatch(setBondsPoints("&bonds=true"))
                      filters.setPageCount(1)
                    }}
                  />
                ) : (
                  <img
                    alt="img"
                    src={checkBoxFull}
                    className={styles.checkBoxEmpty}
                    onClick={() => {
                      dispatch(setSelectBondsPoint(false))
                      dispatch(setBondsPoints(""))
                      filters.setPageCount(1)
                    }}
                  />
                )}
                Облигации
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}
export default SearchSectionFast
